import { defineAsyncComponent } from 'vue';
import i18n from '../translations/i18n';

export enum ThermoSettingsRegion {
  CelsiusFahrenheit,
  TemperatureRange,
  CirculationPumpDelay,
  ButtonsManagement,
  Backlight,
  RegulationBand,
  WindowsContact,
  AutoCommutation,
  ExternalSensorType,
}

export type ThermoSettingsPreference = {
  value: ThermoSettingsRegion | string;
  label: string;
};

const getThermoPreferencesSections = (): ThermoSettingsPreference[] => {
  const preferences = Object.values(ThermoSettingsRegion).filter(
    (value) => typeof value !== 'number'
  );

  return preferences.map((p) => ({
    value: p,
    label: i18n.global.t(`AppResource.${p}`),
  }));
};

const loadThermoPreferencesSectionsComponents = () =>
  Object.fromEntries(
    Object.values(ThermoSettingsRegion)
      .filter((value) => typeof value !== 'number')
      .map((value) => [
        `Preference${value}`,
        defineAsyncComponent(
          () =>
            import(
              `@/views/components/ThermostatPreferencesComponents/Preference${value}/Preference${value}.vue`
            )
        ),
      ])
  );

export {
  getThermoPreferencesSections,
  loadThermoPreferencesSectionsComponents,
};
